import { AwsRum } from 'aws-rum-web';

const RumStage = {
  Alpha: 'Alpha',
  Beta: 'Beta',
  Prod: 'Prod',
};

function determineStage() {
  const hostname = window.location.origin;
  if (hostname.indexOf('alpha') > 0) {
    return RumStage.Alpha;
  } else if (hostname.indexOf('beta') > 0) {
    return RumStage.Beta;
  } else if (hostname.indexOf('prod') > 0) {
    return RumStage.Prod;
  }
  return undefined;
}

const RUM_CONFIGS = {
  Alpha: {
    sessionSampleRate: 1,
    identityPoolId: 'us-east-1:e9eb9d34-5351-4189-ae91-96791de53aa4',
    endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
    telemetries: ['errors', 'performance', 'http'],
    applicationId: '03abd5bb-33af-47f0-bd40-4510a3934765',
    applicationRegion: 'us-east-1',
    applicationVersion: '1.0.0',
  },
  Beta: {
    sessionSampleRate: 1,
    identityPoolId: 'us-east-1:9554bfb3-c4b1-4693-b522-a6505881a72e',
    endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
    telemetries: ['errors', 'performance', 'http'],
    applicationId: '6fb6de37-3fac-4590-ba9e-b30783b4b8c3',
    applicationRegion: 'us-east-1',
    applicationVersion: '1.0.0',
  },
  // TODO: Add Prod config after RUM resources are deployed to production
};

export function initAwsRum() {
  try {
    const stage = determineStage();
    if (!stage) return undefined;

    const rumConfig = RUM_CONFIGS[stage];
    const config = {
      sessionSampleRate: rumConfig.sessionSampleRate,
      identityPoolId: rumConfig.identityPoolId,
      endpoint: rumConfig.endpoint,
      telemetries: rumConfig.telemetries,
      allowCookies: true,
      enableXRay: false,
      signing: false,
    };

    const awsRumClient = new AwsRum(
      rumConfig.applicationId,
      rumConfig.applicationVersion,
      rumConfig.applicationRegion,
      config
    );
    console.log('Successfully initialized CW RUM client');
    return awsRumClient;
  } catch (error) {
    console.log('Error initializing AWS RUM client: ', error);
    return undefined;
  }
}
